module.exports = __webpack_public_path__ + "media/images/traffic-light-2cd8a941157ecf923c73a0d1d6182372.svg";